import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=744b1aac"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744b1aac')) {
      api.createRecord('744b1aac', component.options)
    } else {
      api.reload('744b1aac', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=744b1aac", function () {
      api.rerender('744b1aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/Breadcrumbs.vue"
export default component.exports